import { render, staticRenderFns } from "./CusDocBook.vue?vue&type=template&id=6660961d&scoped=true&"
import script from "./CusDocBook.vue?vue&type=script&lang=js&"
export * from "./CusDocBook.vue?vue&type=script&lang=js&"
import style0 from "./CusDocBook.vue?vue&type=style&index=0&id=6660961d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6660961d",
  null
  
)

export default component.exports